export const isPacksizeUser = (permissions: string[] | undefined): boolean => {
	if (!permissions) {
		return false;
	}

	return permissions.some((permission) => permission.toLowerCase() === "packsizeuser");
};

export const isPacksizePartner = (permissions: string[] | undefined): boolean => {
	if (!permissions) {
		return false;
	}

	return permissions.some((permission) => permission.toLowerCase() === "packsizepartner");
};
